import { useMutation, useQueryClient } from '@tanstack/react-query'

import { GENERIC_ERROR_MESSAGE } from '../../constants/error-message'
import { ToastStatus } from '../../constants/toastMessage.constants'

import API from '../../services/api'
import { toastService } from '../../services/toast.service'

// hooks
import useAnalytics from '../helper/useAnalytics'
import surfaceKeys from '../surface/_queryKeys'
import formulaKeys from './_queryKeys'

const useFormulaApprove = (formulaId) => {
    const queryClient = useQueryClient()

    const { track } = useAnalytics()

    return useMutation({
        mutationFn: API.approveFormula,
        onError: (err, approvedFormula, context) => {
            // No onMutate sets a snapshot today, so context is undefined;
            // reading it unguarded threw and hid the backend error.
            if (context?.previousFormulaData) {
                queryClient.setQueryData(
                    formulaKeys.formulaById(formulaId),
                    context.previousFormulaData,
                )
            }
            // Surface backend rejections (e.g. a real-time trigger without
            // allow_responsive_formulas) instead of failing silently.
            toastService.showNotificationToast(
                ToastStatus.Error,
                err?.message || GENERIC_ERROR_MESSAGE,
            )
        },
        onSuccess: (data) => {
            track('formula_approved', {
                formula_id: formulaId,
            })
            queryClient.setQueryData(
                formulaKeys.approvedFormulaById(formulaId),
                data.data,
            )
            queryClient.invalidateQueries({ queryKey: surfaceKeys.all() })
        },
    })
}

export default useFormulaApprove
